import { render, staticRenderFns } from "./sp_form_success.html?vue&type=template&id=47374c58&scoped=true&"
import script from "./sp_form_success.vue?vue&type=script&scoped=true&lang=js&"
export * from "./sp_form_success.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./sp_form_success.scss?vue&type=style&index=0&id=47374c58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47374c58",
  null
  
)

export default component.exports